var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "request-dialog-mask",
      class: { "request-dialog-mask--sp": _vm.isSpScreen },
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onMaskClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "request-dialog",
          class: { "request-dialog--work": _vm.step === "work" },
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-label": _vm.headerTitle,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "request-dialog__header",
              class: { "request-dialog__header--variant": _vm.step !== "work" },
            },
            [
              _vm.step !== "work" || _vm.isSpScreen
                ? _c(
                    "button",
                    {
                      staticClass: "request-dialog__back",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.$t("assistantCatHome.back"),
                      },
                      on: { click: _vm.onHeaderBack },
                    },
                    [_c("icon-arrow-left")],
                    1
                  )
                : _vm._e(),
              _c("h2", { staticClass: "request-dialog__title" }, [
                _vm._v(_vm._s(_vm.headerTitle)),
              ]),
              !_vm.isSpScreen
                ? _c(
                    "button",
                    {
                      staticClass: "request-dialog__close",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.$t("common.close"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm.step === "work"
            ? _c(
                "div",
                { staticClass: "request-dialog__body" },
                [
                  _c("assistant-cat-home-work-select-prompt", {
                    attrs: {
                      message: _vm.prompt,
                      "writer-type": _vm.writerType,
                    },
                  }),
                  _c("assistant-cat-home-work-toolbar", {
                    attrs: {
                      "search-query": _vm.searchQuery,
                      "search-expanded": _vm.searchExpanded,
                      "has-active-filter": _vm.hasActiveFilter,
                    },
                    on: {
                      "update:searchQuery": function ($event) {
                        _vm.searchQuery = $event
                      },
                      "update:searchExpanded": function ($event) {
                        _vm.searchExpanded = $event
                      },
                      "open-filter": _vm.onOpenFilter,
                    },
                  }),
                  _vm.isLoadingNovels
                    ? _c("div", { staticClass: "request-dialog__status" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("assistantCatHome.workSelect.loading")
                            ) +
                            " "
                        ),
                      ])
                    : _vm.isOpeningNovel
                    ? _c("div", { staticClass: "request-dialog__status" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("assistantCatHome.workSelect.loading")
                            ) +
                            " "
                        ),
                      ])
                    : _vm.loadError
                    ? _c("div", { staticClass: "request-dialog__status" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("assistantCatHome.workSelect.loadError")
                            )
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "request-dialog__retry",
                            attrs: { type: "button" },
                            on: { click: _vm.loadNovels },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "assistantCatHome.connectionError.retry"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ])
                    : _vm.filteredNovels.length === 0
                    ? _c("div", { staticClass: "request-dialog__status" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("assistantCatHome.workSelect.empty")
                            ) +
                            " "
                        ),
                      ])
                    : _c(
                        "div",
                        { staticClass: "request-dialog__novels" },
                        _vm._l(_vm.filteredNovels, function (novel, index) {
                          return _c("assistant-cat-home-work-list-item", {
                            key: novel.novelId,
                            staticClass: "request-dialog__novel",
                            class: {
                              "request-dialog__novel--stripe": index % 2 === 1,
                            },
                            attrs: {
                              novel: novel,
                              disabled: _vm.isOpeningNovel,
                              "is-script-mode-masked": _vm.isNovelScriptModeMasked(
                                novel
                              ),
                            },
                            on: {
                              select: function ($event) {
                                return _vm.onSelectNovel(novel)
                              },
                            },
                          })
                        }),
                        1
                      ),
                ],
                1
              )
            : _vm.resultAssist
            ? _c(
                "div",
                {
                  staticClass:
                    "request-dialog__body request-dialog__body--embed",
                },
                [
                  _c("assistant-cat-home-result-dialog", {
                    attrs: { embedded: "", assist: _vm.resultAssist },
                    on: { close: _vm.onCloseResult },
                  }),
                ],
                1
              )
            : _vm.step === "manuscript" &&
              _vm.selectedNovel &&
              _vm.contentTab === "request"
            ? _c(
                "div",
                {
                  staticClass:
                    "request-dialog__body request-dialog__body--embed",
                },
                [
                  _c("manuscript-select-content", {
                    attrs: {
                      "novel-id": _vm.selectedNovel.novelId,
                      "request-type": _vm.manuscriptRequestType,
                      standalone: "",
                    },
                    on: { "request-succeeded": _vm.onRequestSucceeded },
                  }),
                ],
                1
              )
            : _vm.step === "theme" &&
              _vm.selectedNovel &&
              _vm.contentTab === "request"
            ? _c(
                "div",
                {
                  staticClass:
                    "request-dialog__body request-dialog__body--embed",
                },
                [
                  _vm.isLoadingTheme
                    ? _c("div", { staticClass: "request-dialog__status" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("assistantCatHome.workSelect.loading")
                            ) +
                            " "
                        ),
                      ])
                    : _c("theme-review-confirm-content", {
                        attrs: {
                          "novel-id": _vm.selectedNovel.novelId,
                          "assist-kind": _vm.themeKind,
                          standalone: "",
                        },
                        on: {
                          back: _vm.onBackToWork,
                          "request-succeeded": _vm.onRequestSucceeded,
                        },
                      }),
                ],
                1
              )
            : _vm.step !== "work" && _vm.contentTab === "history"
            ? _c(
                "div",
                {
                  staticClass:
                    "request-dialog__body request-dialog__body--embed request-dialog__body--history",
                },
                [
                  _c("history-list-content", {
                    attrs: {
                      "function-type": _vm.assistFunctionType,
                      "navigate-on-click": false,
                      "empty-text": _vm.$t("assistantCatHome.history.empty"),
                      "empty-subtext": _vm.$t(
                        "assistantCatHome.history.emptyHint"
                      ),
                    },
                    on: { select: _vm.onHistorySelect },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.step !== "work" && !_vm.resultAssist
            ? _c("assistant-cat-home-assist-tabs", {
                attrs: { "active-tab": _vm.contentTab },
                on: {
                  "update:activeTab": function ($event) {
                    _vm.contentTab = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }